export default {
    photographers: {},
    availableRegions: [],
    addressPointLocation: {},
    locationData: {}
};
